// TourCard: displays a tour summary card with CTA
import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

export default function TourCard({ tour }) {
  const { settings } = useSettings();
  const cs = settings.currency_symbol || "$";
  const discount = Number(settings.discount_percentage) || 0;
  if (!tour) return null;
  const discountedPrice = discount > 0 ? (tour.price * (1 - discount / 100)).toFixed(2) : null;
  return (
    <Link
      to={`/tours/${tour.id}`}
      className="group block overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all hover:shadow-lg hover:-translate-y-1 dark:border-slate-800 dark:bg-slate-900"
    >
      <div className="relative overflow-hidden">
        <img
          src={tour.thumbnail || "/emogiesnack.png"}
          alt={tour.title}
          loading="lazy"
          className="h-48 w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute top-3 right-3">
          <span className="rounded-full bg-white/90 backdrop-blur-sm px-2.5 py-1 text-xs font-semibold text-amber-600 shadow-sm dark:bg-slate-900/90 dark:text-amber-400">
            {tour.rating}★
          </span>
        </div>
      </div>
      <div className="space-y-3 p-4">
        <div>
          <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 group-hover:text-emerald-600 dark:group-hover:text-emerald-400 transition-colors">
            {tour.title}
          </h3>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">
            {tour.city} · {tour.durationDays} days
          </p>
        </div>
        <div className="flex items-center justify-between pt-2 border-t border-slate-100 dark:border-slate-800">
          <div className="flex items-center gap-2">
            {discountedPrice ? (
              <>
                <span className="text-sm line-through text-slate-400">{cs}{tour.price}</span>
                <span className="text-lg font-bold text-emerald-600">{cs}{discountedPrice}</span>
                <span className="text-xs bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 px-1.5 py-0.5 rounded-full font-semibold">-{discount}%</span>
              </>
            ) : (
              <span className="text-lg font-bold text-emerald-600">{cs}{tour.price}</span>
            )}
          </div>
          <span className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white group-hover:bg-emerald-600 transition-colors dark:bg-slate-100 dark:text-slate-900 dark:group-hover:bg-emerald-500 dark:group-hover:text-white">
            See details
          </span>
        </div>
      </div>
    </Link>
  );
}
